<template>
  <div>
    <rzo-cross-connect
    @ticketCreated="$router.push({ name: 'tasks', params: { selectedTaskId: $event.id }})" 
  />
  </div>
</template>

<script>
import RzoCrossConnect from "@/components/orders/rzo/RzoCrossConnect";


export default {
  name: "RzoCrossConnectOrder",
  components: {
    RzoCrossConnect,
  },
  props: {
    reference: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>